import { render, staticRenderFns } from "./ShipmentManager.vue?vue&type=template&id=704283c2&"
import script from "./ShipmentManager.vue?vue&type=script&lang=js&"
export * from "./ShipmentManager.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentManager.vue?vue&type=style&index=0&id=704283c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports